export enum UserRoleEnums {
  SUPER_ADMIN="SUPER_ADMIN",
  USER="USER",
  ADMIN="ADMIN"
}